import Vue from 'vue'
import { cloneDeep } from 'lodash'

export default Vue.extend({
  name: 'TermConditionDialog',
  data() {
    return {
      agreements: [],
      valid: false,
      serviceURL: process.env.VUE_APP_TERMS_OF_SERVICE,
      purchaseURL: process.env.VUE_APP_TERMS_OF_PURCHASE
    }
  },
  props: {
    show: Boolean,
    title: {
      type: String,
      default: '利用規約が更新されました。'
    },
    description: {
      type: String,
      default: '以下の規約をご確認ください。'
    },
    confirm: {
      type: String,
      default: '確認しました'
    },
    confirmColor: {
      type: String,
      default: 'green'
    },
    terms: {
      type: Array
    }
  },
  mounted() {
    this.agreements = cloneDeep(this.terms)
    const requiredAgreement = this.agreements.filter(item => item.require_confirmation);
    this.agreements = requiredAgreement
    this.agreements.forEach((a, index) => {
      Object.assign(a, {
        agreed: false
      })
    })
  },
  methods: {
    validationCheck () {
      const confirmedAgreement = this.agreements.filter(item => item.require_confirmation && item.agreed);
      this.valid = confirmedAgreement.length === this.agreements.length
    },
    submit () {
      const arr = []
      this.agreements.forEach((a) => {
        arr.push(a.id)
      })
      this.$emit('submit', arr)
    }
  }
})
